
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 19.167A9.167 9.167 0 1010 .833a9.167 9.167 0 000 18.334zm1.022-13.803a.929.929 0 00-.751-.34c-.283 0-.538.114-.765.34-.227.227-.35.505-.368.836-.01.321.08.595.269.822.198.217.458.325.779.325.312 0 .571-.108.78-.325.207-.227.316-.5.325-.822.019-.33-.07-.61-.27-.836zm-.227 3.683c-.189-.302-.529-.453-1.02-.453-.321 0-.61.076-.864.227a2.53 2.53 0 00-.652.58 3.36 3.36 0 00-.439.723 3.174 3.174 0 00-.227.68l.765.227c.123-.425.241-.718.355-.879.113-.16.222-.24.325-.24.057 0 .109.023.156.07.047.038.071.137.071.298 0 .227-.024.515-.07.864a41.4 41.4 0 01-.17 1.105c-.057.397-.11.784-.157 1.162-.047.378-.07.703-.07.977 0 .5.094.893.283 1.176.198.284.557.425 1.077.425.32 0 .604-.075.85-.227.255-.15.472-.34.651-.566.18-.236.321-.482.425-.737.114-.255.19-.482.227-.68l-.765-.226c-.123.424-.24.717-.354.878-.114.16-.227.24-.34.24-.047 0-.095-.023-.142-.07-.047-.047-.07-.147-.07-.298 0-.16.023-.415.07-.765.047-.35.1-.736.156-1.161.057-.425.109-.831.156-1.219.047-.387.07-.694.07-.92 0-.501-.099-.898-.297-1.19z","fill":"#51338B"}})])
          )
        }
      }
    